import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.css";

const Table = ({ group, children }) => {
  return (
    <div className={styles.root}>
      {/* <h1 className={styles.title}>{title}</h1> */}
      <table className={styles.table}>
        <thead className={styles.thead}>
          <tr className={styles.tr}>
            {group.categories.map(category => (
              <th key={category} className={styles.th}>
                {category}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className={styles.tbody}>
          {group.series.map(series => (
            <tr key={series.name} className={styles.tr}>
              {series.data.map((data, index) => (
                <td key={index} className={styles.td}>
                  {data}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <div className={styles.footer}>{children}</div>
    </div>
  );
};

Table.propTypes = {
  group: PropTypes.shape({
    categories: PropTypes.arrayOf(PropTypes.string),
    series: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        data: PropTypes.arrayOf(
          PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        )
      })
    )
  })
  // title: PropTypes.string
};

export default Table;



// WEBPACK FOOTER //
// ./src/components/Table/index.js